import styled from 'styled-components';

const Button = styled.button`
  -webkit-tap-highlight-color: transparent;
  flex-shrink: 0;
  margin: 0.2em auto;
  height: ${props => `${props.buttonHeight || 3}em`};
  width: 100%;
  border-radius: ${props =>
    props.circular ? `${(props.buttonHeight || 3) / 2}em` : '0.3em'};
  background: ${props => props.theme.primary};
  border: none;
  color: white;
  :focus {
    outline: none;
  }
  :disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export default Button;
